import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { AuthService } from './auth.service';
import { ICreateInsuranceEnrollmentRequest, IEnrollAllResult, IInsuranceEnrollment } from '../interfaces/insurance.interface';

const headers = () => AuthService.getAuthHeader();

export const InsuranceEnrollmentService = {
    listOpenForPolicy: async (institutionId: string, policyId: string): Promise<IInsuranceEnrollment[]> => {
        const res = await axios.get(ENDPOINTS.INSURANCE_ENROLLMENT.LIST(institutionId, policyId), { headers: headers() });
        return res.data;
    },

    create: async (institutionId: string, request: ICreateInsuranceEnrollmentRequest): Promise<IInsuranceEnrollment> => {
        const res = await axios.post(ENDPOINTS.INSURANCE_ENROLLMENT.CREATE(institutionId), request, { headers: headers() });
        return res.data;
    },

    end: async (institutionId: string, id: string): Promise<IInsuranceEnrollment> => {
        const res = await axios.post(ENDPOINTS.INSURANCE_ENROLLMENT.END(institutionId, id), null, { headers: headers() });
        return res.data;
    },

    previewEnrollAll: async (institutionId: string, policyId: string): Promise<IEnrollAllResult> => {
        const res = await axios.get(ENDPOINTS.INSURANCE_ENROLLMENT.ENROLL_ALL_PREVIEW(institutionId, policyId), { headers: headers() });
        return res.data;
    },

    enrollAll: async (institutionId: string, policyId: string): Promise<IEnrollAllResult> => {
        const res = await axios.post(ENDPOINTS.INSURANCE_ENROLLMENT.ENROLL_ALL(institutionId, policyId), null, { headers: headers() });
        return res.data;
    },
};
